/**
 * 后端接口地址解析（后台管理端与浏览上报共用）。
 *
 * 解析顺序：
 *   1. VUE_APP_ADMIN_API（在 .env.* 里显式指定，最优先）
 *   2. 页面跑在本机开发服务器上（如 :8080）→ 指到本机后端 :5000
 *   3. 其它情况一律同源（后端直接托管前端产物，或 Nginx 反向代理到后端都适用）
 *
 * 之所以不用 NODE_ENV 判断：构建产物的 NODE_ENV 会随 --mode 变化，
 * 曾经导致打包后仍写死 localhost:5000，同源部署时反被 CORS 拦掉。
 */

const LOCAL_HOSTS = ['localhost', '127.0.0.1', '[::1]'];

function resolveBase() {
    const fromEnv = process.env.VUE_APP_ADMIN_API;
    if (fromEnv) {
        return String(fromEnv).replace(/\/+$/, '');
    }

    const loc = (typeof window !== 'undefined' && window.location) || {};
    const host = loc.hostname || '';
    const port = loc.port || '';
    const proto = loc.protocol || 'http:';

    // 本机开发服务器（vue-cli-service serve 默认 8080 等）→ 指向本机后端
    if (LOCAL_HOSTS.indexOf(host) > -1 && port !== '5000') {
        return proto + '//' + host + ':5000';
    }

    // 同源：后端托管静态产物、或反向代理
    if (loc.origin && loc.origin !== 'null') {
        return loc.origin;
    }

    // file:// 直接打开等极端情况
    return 'http://localhost:5000';
}

export const API_BASE = resolveBase();

export default API_BASE;
